import { encryptKey, decryptKey } from '../core/aes'
import { createSymmetricEncryptionKeyFromPrivateKey } from '../core/ecc'
import { deriveKey } from '../core/key-derivation'
import { createSymmetricEncryptionWrapper, createAsymmetricEncryptionWrapper } from './format'

/**
 * Encrypt key symmetrically
 *
 * @param {Base64UrlString} key
 * @param {DerivationParams} derivationParams
 * @param {SymmetricEncryptionParams} encryptionParams
 * @param {String} password
 * @param {String} hint
 * @return {SymmetricEncryptionWrapper}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function encryptWithSymmetricEncryption (key, derivationParams, encryptionParams, password, hint) {
  return createSymmetricEncryptionWrapper(hint, derivationParams, encryptionParams, encryptKey(key, deriveKey(password, derivationParams), encryptionParams))
}

/**
 * Decrypt key symmetrically
 *
 * @param {String} password
 * @param {SymmetricEncryptionWrapper} symmetricEncryptionWrapper
 * @return {Base64UrlString}
 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
 * @private
 */
export function decryptWithSymmetricEncryption (password, symmetricEncryptionWrapper) {
  return decryptKey(symmetricEncryptionWrapper.encryptedKey, deriveKey(password, symmetricEncryptionWrapper.derivationParams), symmetricEncryptionWrapper.encryptionParams)
}

/**
 * Encrypt key asymmetrically
 *
 * @param {Base64UrlString} key
 * @param {Base64UrlString} tag
 * @param {SymmetricEncryptionParams} encryptionParams
 * @param {Base64UrlString} encryptionKey
 * @param {String} id
 * @param {String} version
 * @return {AsymmetricEncryptionWrapper}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function encryptWithAsymmetricEncryption (key, tag, encryptionParams, encryptionKey, id, version) {
  return createAsymmetricEncryptionWrapper(id, version, tag, encryptionParams, encryptKey(key, encryptionKey, encryptionParams))
}

/**
 * Decrypt key asymmetrically
 *
 * @param {ElGamalPrivateKey} privateKey
 * @param {AsymmetricEncryptionWrapper} asymmetricEncryptionWrapper
 * @return {Base64UrlString}
 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
 * @private
 */
export function decryptWithAsymmetricEncryption (privateKey, asymmetricEncryptionWrapper) {
  return decryptKey(asymmetricEncryptionWrapper.encryptedKey, createSymmetricEncryptionKeyFromPrivateKey(privateKey, asymmetricEncryptionWrapper.tag), asymmetricEncryptionWrapper.encryptionParams)
}



// WEBPACK FOOTER //
// ./src/record/key.js